<template>
  <section class="button-full-video">
    <div>
      <h2 v-if="shopifyData.sectionUpperTitle" class="button-full-video_title">
        <span v-html="sanitizeHtml(shopifyData.sectionUpperTitle)" />
        <span v-html="sanitizeHtml(shopifyData.sectionLowerTitle)" />
      </h2>
      <div class="video_container">
        <iframe
          ref="videoElement"
          :src="youtubeEmbedUrl"
          :allow="showControls ? 'autoplay; encrypted-media' : 'encrypted-media'"
          frameborder="0"
          allowfullscreen
          webkit-playsinline="true"
          playsinline="true"
          class="fullIframe"
        />
      </div>
    </div>
  </section>
</template>

<script>
/* global YT */
import { sanitizeHtml } from '@/sanitizeContent.js';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showControls: false,
      player: null,
    };
  },
  computed: {
    youtubeEmbedUrl() {
      const youtubeLink = this.shopifyData.videolink;
      const videoIdMatch = youtubeLink.match(
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)|youtu\.be\/([^&]+)/
      );
      const videoId = videoIdMatch ? videoIdMatch[1] || videoIdMatch[2] : null;
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;
      }
      return youtubeLink;
    },
  },
  mounted() {
    this.loadYouTubeAPI();
    this.observeVideo(); // Start observing the video when the component is mounted
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy();
    }
  },
  methods: {
    sanitizeHtml,
    onPlayerReady(event) {
      // console.log('YouTube Player is ready', event);
      this.player = event.target;
      this.showControls = true;
    },
    loadYouTubeAPI() {
      if (!window.YT) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = this.createPlayer;
      } else {
        this.createPlayer();
      }
    },
    createPlayer() {
      this.player = new YT.Player(this.$refs.videoElement, {
        events: {
          onReady: this.onPlayerReady,
        },
      });
      // console.log('Player instance created:', this.player); // Log the player instance
    },
    observeVideo() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.player) {
              console.log('Video is in viewport');
            } else {
              console.warn('Player is not ready yet');
            }
            observer.unobserve(entry.target); // Stop observing after video is in viewport
          }
        });
      }, options);

      observer.observe(this.$refs.videoElement);
    },
  },
};
</script>
<style>
.video_container .ytp-chrome-top.ytp-show-cards-title {
  display: none;
}

.video_container .ytp-chrome-top {
  display: none;
}
</style>

<style scoped>
.button-full-video iframe {
  height: 80vh;
  width: 100%;
}

.button-full-video_title {
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 16px;
}

.button-full-video_title span {
  font-size: 57px;
  font-style: italic;
  font-weight: 200;
  line-height: 1.5;
  text-align: center;
  color: #581a1a;
  font-family: 'PP Editorial New', sans-serif;
}

.video_container {
  position: relative;
  width: 100%;
  height: 100%;
  /* Full height */
}

.full-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 800px;
  height: 800px;
  display: none;
  /* Hide initially, use v-show to toggle */
}

.video_overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  background: #5b373a;
  opacity: 0.5;
}

.button-full-video_playButton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  cursor: pointer;
}

.button-full-video_playButton svg {
  transition: transform 0.3s;
}

.button-full-video_playButton svg:hover {
  transform: scale(1.1);
}

.ytp-title-text {
  display: none;
}

.ytp-embed:not(.ad-showing) .ytp-gradient-top {
  display: none;
}

.video_container .ytp-chrome-top.ytp-show-cards-title {
  display: none;
}

.video_container .ytp-chrome-top {
  display: none;
}

.button-full-video {
  margin-bottom: -4px;
}

@media (max-width: 768px) {
  .button-full-video_title span {
    font-size: 47px;
  }
}

@media screen and (max-width: 567px) {
  .button-full-video_title span {
    display: block;
    font-size: 35px;
    line-height: 50.05px;
  }

  .button-full-video_playButton svg {
    transform: scale(0.6);
  }

  .button-full-video_title {
    padding: 13px;
    display: block;
  }

  .button-full-video {
    margin-bottom: -4px;
  }

  .ytp-large-play-button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    margin-left: 0;
    margin-top: 0;
  }

  .button-full-video iframe {
    height: 56vh;
  }
}
</style>
